import { render } from "./PosterCaptionsMenuComponent.vue?vue&type=template&id=937e58aa&scoped=true&ts=true"
import script from "./PosterCaptionsMenuComponent.vue?vue&type=script&lang=ts"
export * from "./PosterCaptionsMenuComponent.vue?vue&type=script&lang=ts"

import "./PosterCaptionsMenuComponent.vue?vue&type=style&index=0&id=937e58aa&lang=scss&scoped=true"
import "./PosterCaptionsMenuComponent.vue?vue&type=style&index=1&id=937e58aa&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937e58aa"]])

export default __exports__